// translations/ja.ts
import { TranslationKeys } from '../index';

export const ja: TranslationKeys = {
  header: {
    tutorialButton: "チュートリアル",
    currentLanguage: "現在"
  },
  hero: {
    title: "今すぐ数独VSをプレイ！",
    description: "他にはない数独チャレンジに備えましょう！ソロ練習を楽しんだり、友達と対戦したり — 今すぐダウンロードして興奮を体験してください！",
    howToPlay: "遊び方",
    googlePlay: {
      topText: "で入手",
      bottomText: "Google Play"
    },
    appStore: {
      topText: "でダウンロード",
      bottomText: "App Store"
    },
    botButtonShow: "ヘルプが必要ですか？ボットに質問！",
    botButtonHide: "アシスタントを非表示"
  },
  footer: {
    followUs: "フォローする",
    handle: "@SUDOKU.VS",
    copyright: "© 2024 Sudoku VS. 無断複写・転載を禁じます。"
  },
  beginnersGuide: {
    modalTitle: "初心者ガイド",
    originsTab: "数独の起源",
    basicsTab: "数独の基本",
    rulesTab: "VSゲームルール",
    origins: {
      bulletOne: "ラテン方格から着想を得て、1979年にハワード・ガーンズによって初めて出版されました。",
      bulletTwo: "1980年代に日本で人気を博し、「数独」と改名されました。2000年代に世界的な名声を得ました。",
      bulletThree: "9つの3x3のサブグリッドを持つ9x9のグリッド。行、列、またはサブグリッド内で数字を繰り返さずに1から9までを埋めます。",
      bulletFour: "多くのバリエーションと新しい挑戦で、何百万人もの人々に愛されています。",
      gridSize: {
        four: "4 X 4",
        six: "6 X 6",
        nine: "9 X 9",
      }
    },
    basics: {
      fillMissing: "欠けている数字を埋めてください！",
      correct: "正解！",
      incorrect: "不正解",
      instructions: "ハイライトされたスペースに正しい数字を入力して、3X3パズルを完成させてください。各行、各列、各ボックスには、すべての数字が一度だけ含まれている必要があります。正しい数字を選択してください。賢く選びましょう！",
      feedbackCorrect: "最初のボックスを解決しました！",
      feedbackIncorrect: "もう一度試してください！",
      basicsStep2: {
        instructions: "ハイライトされたスペースに正しい数字を選択して、4X4パズルを完成させてください。各行、各列、各ボックスには、すべての数字が一度だけ含まれている必要があります。正しい数字を選択してください。賢く選びましょう！",
        feedbackCorrect: "絶好調ですね！"
      },
      basicsStep3: {
        instructions: "ハイライトされたスペースに正しい数字を選択して、4X4パズルを完成させてください。各行、各列、各ボックスには、すべての数字が一度だけ含まれている必要があります。正しい数字を選択してください。賢く選びましょう！",
        feedbackCorrect: "完璧な解答です！",
        feedbackIncorrect: "不正解 - もう一度試してください！"
      },
      congratulations: {
        title: "おめでとうございます！",
        subtitle: "数独の基本チュートリアルを無事に完了しました！あなたの献身と努力が実を結び、自信を持って数独パズルに取り組むための基本的なスキルを身につけました。",
        nextStepsTitle: "次のステップ",
        nextStepsText: "さあ、あなたのスキルを試す時が来ました！今日、数独ゲームをダウンロードして、さまざまなパズルに没頭してください。素早いシングルゲームを好むか、親善試合に参加したいかにかかわらず、シングルモードまたは対戦相手とのVSモードでプレイすることを選択できます。",
        ctaHeader: "ゲームはいかがですか？",
        ctaHighlight: "今すぐダウンロード！",
        rulesTitle: "ゲームルールをマスターする",
        rulesText: "始める前に、必ずSudoku VSのゲームルールを確認してください。ルールとポイントシステムを理解することで、対戦相手とプレイする際に有利になります。この知識はあなたの経験を向上させ、効果的に戦略を立てるのに役立ちます！"
      }
    },
    gameRules: {
      notification: {
        important: "重要：",
        text: "最高の体験のために通知を有効にしてください！"
      },
      rulesHeader: "ルール",
      rulesList: {
        rule1_pre: "フレンドリーマッチまたはランダムマッチの招待を",
        rule1_strong: "受け入れるか、作成します。",
        rule1_post: "",
        rule2_pre: "プレイヤーは",
        rule2_strong: "ランダムに選ばれて先攻となります。",
        rule3: "ボードが完成するまでプレイヤーは交代でプレイします。",
        rule4_pre1: "各ターンは",
        rule4_strong1: "60秒間続き、",
        rule4_pre2: "1ターンあたり",
        rule4_strong2: "5つの数字の制限があります。",
        rule5_pre: "1ターンに",
        rule5_strong: "1つのヒント",
        rule5_post: "のみが許可されます。",
        rule6_pre: "最も",
        rule6_strong: "高いスコアのプレイヤーが",
        rule6_post: "ゲームに勝ちます。",
        rule7_pre: "引き分けの場合、",
        rule7_strong_pre: "より多くの入力を行った",
        rule7_pre2: "プレイヤーが",
        rule7_strong_post: "ゲームに",
        rule7_post: "勝ちます。",
        rule8: "24時間以内にターンを終了しない場合、自動的にゲームを棄権したことになります。"
      },
      rulesWarning: "24時間以内にターンをプレイしないと、自動的にゲームを棄権したことになります",
      gameControls: {
        header: "ゲームコントロール",
        list: {
          control1_pre: "ゲームを棄権するには",
          control1_strong: "降参フラグ",
          control1_post: "を使用します。",
          control2_pre: "間違いを訂正するには",
          control2_strong: "消しゴム",
          control2_post: "を使用します。",
          control3_pre: "タイマーが切れる前に入力をすべて完了した場合は、",
          control3_strong: "ターン終了",
          control3_post: "を使用します。"
        }
      },
      scoring: {
        header: "スコアリング",
        list: {
          score1_pre1: "正しい数字の配置で",
          score1_strong1: "1ポイント",
          score1_pre2: "を獲得します。",
          score1_span: "正しい",
          score1_post: "",
          score2_pre1: "間違った数字の配置ごとに",
          score2_strong1: "1ポイント",
          score2_pre2: "を失います。",
          score2_span: "間違った",
          score2_post: "",
          score3_pre1: "解決された各行、列、ボックスごとに",
          score3_strong1: "5ポイント",
          score3_pre2: "を獲得します。",
          score3_span: "解決された",
          score3_post: ""
        }
      },
    },
    controller: {
      previous: "前へ",
      of: " / ",
      close: "閉じる",
      next: "次へ",
      gameRules: "ゲームルール",
    },
  },
  tutorials: {
    modalTitle: "チュートリアル",
    tabs: {
      introduction: "はじめに",
      gettingStarted: "入門",
      vsFriends: "友達と対戦",
      howToPlay: "遊び方",
    },
    messages: {
      loading: "チュートリアルを読み込んでいます...",
      error: "チュートリアルの読み込み中にエラーが発生しました:",
      fallback: "フォールバックデータを使用しています...",
      empty: "このセクションには利用可能なチュートリアルがありません。",
    },
  },
  cookieConsent: {
    title: "同意設定の管理",
    description: "当サイトでは、お客様のSudoku VS体験の向上、トラフィックの分析、パーソナライズされた広告の提供のためにCookieを使用しています。",
    acceptAll: "すべてのCookieを受け入れる",
    confirmChoices: "選択を確定する",
    performance: {
      title: "パフォーマンスCookie",
      description: "利用状況分析を通じて、ゲームやサービスを改善するためのデータを収集することを許可します。"
    },
    advertising: {
      title: "広告",
      adStorage: "デバイスへの広告データの保存を許可します",
      adMeasurement: "広告測定のためのデータ収集を許可します",
      adPersonalization: "お客様の興味に基づいてパーソナライズされた広告を表示することを許可します"
    },
    landing: {
        title: "Cookieに関するお知らせ",
        description: "当サイトでは、お客様のSudoku VS体験の向上、トラフィックの分析、パーソナライズされた広告の提供のためにCookieを使用しています。続行する前に、許可するCookieを設定できます。",
        acceptAll: "すべてのCookieを受け入れる",
        customizeSettings: "設定のカスタマイズ",
        fineprint: "「すべてのCookieを受け入れる」をクリックすると、<br />Sudoku VSがデバイスにCookieを保存することに同意したことになります"
    }
  },
    privacyPolicy: {
    modalTitle: "プライバシーポリシー",
    sections: {
      introduction: {
        title: "1. はじめに",
        p1: "Sudoku VSへようこそ。私たちは、お客様のプライバシーを保護し、当社のウェブサイトでポジティブな体験をしていただくことに取り組んでいます。このプライバシーポリシーは、Sudokuゲームプラットフォームをご利用いただく際に、お客様の情報をどのように収集、使用、保護するかを説明します。",
        p2: "Sudoku VSをご利用になることで、お客様はこのポリシーに従った情報の収集と使用に同意したものとみなされます。"
      },
      informationWeCollect: {
        title: "2. 収集する情報",
        p1: "当社はサービスを提供し改善するために、さまざまな種類の情報を収集します:",
        list: {
          usageData: "利用データ: ゲームプレイ統計、パズル完了時間、プレイした難易度レベル、ゲーム設定など、ゲームとのインタラクション方法に関する情報を自動的に収集します。",
          deviceInfo: "デバイス情報: Sudoku VSにアクセスするために使用するデバイスに関する情報（デバイスタイプ、ブラウザタイプ、IPアドレス、オペレーティングシステムなど）を収集する場合があります。",
          cookies: "Cookieとトラッキングデータ: お客様の体験を向上させ、分析データを収集するために、Cookieおよび類似のトラッキング技術を使用します。"
        }
      },
      howWeUseInfo: {
        title: "3. 情報の使用方法",
        p1: "収集した情報は以下の目的で使用します:",
        list: {
          gameImprovement: "ゲーム改善: ゲームプレイパターンを分析し、Sudokuパズル、難易度アルゴリズム、全体的なユーザーエクスペリエンスを改善するため。",
          performanceAnalytics: "パフォーマンス分析: 利用トレンドを監視・分析し、サービスの効果を測定し、改善すべき領域を特定するため。",
          personalization: "パーソナライゼーション: プレイ設定に基づいて、パーソナライズされたゲーム推奨と調整されたコンテンツを提供するため。",
          technicalSupport: "テクニカルサポート: 問題のトラブルシューティング、バグの修正、プラットフォームの円滑な運用を確保するため。"
        }
      },
      cookies: {
        title: "4. Cookieとトラッキング技術",
        p1: "Sudoku VSは、お客様の体験を向上させるためにCookieを使用します。Cookie設定を管理するオプションがあります:",
        performanceCookies: {
          title: "パフォーマンスCookie:",
          description: "これらのCookieにより、利用分析を通じてゲームとサービスを改善するためのデータを収集できます。プレイヤーがパズルとどのようにインタラクションするか、どの機能が最も人気があるか、どこを改善できるかを理解するのに役立ちます。このデータはゲームプレイを強化し、より良いSudoku体験を作成するために不可欠です。"
        },
        advertisingCookies: {
          title: "広告Cookie:",
          list: [
            "お客様のデバイスへの広告データの保存を許可します",
            "広告測定と効果のためのデータ収集を有効にします",
            "お客様の興味とゲーム行動に基づいてパーソナライズされた広告を表示できるようにします"
          ]
        },
        p2: "当社のウェブサイトに初めてアクセスしたときに表示されるCookie同意バナーを通じてCookie設定を制御できます。ブラウザ設定を通じていつでも設定を変更できますが、特定のCookieを無効にするとウェブサイトの機能に影響する場合があります。"
      },
      thirdParty: {
        title: "5. 第三者サービス",
        p1: "Sudoku VSは以下の第三者サービスと統合されています:",
        gemini: {
          title: "Google Gemini AIアシスタント:",
          description: "当社のヘルプボットは、組み込みのナレッジベースを備えたGoogle Geminiによって動作し、ゲーム関連の質問のサポート、Sudokuのヒントの提供、問題のトラブルシューティングを支援します。ボットと対話する場合、お客様のクエリはGoogleのシステムによって処理される可能性があります。データの取り扱い方法については、Googleのプライバシーポリシーを参照してください。"
        },
        youtube: {
          title: "YouTube埋め込み動画:",
          description: "チュートリアルコンテンツとゲームプレイガイドをウェブサイト内で直接提供するために、YouTubeビデオオーバーレイを使用します。これらの動画と対話する場合、YouTubeはそのプライバシーポリシーに従ってデータを収集する可能性があります。Sudoku VSを離れることなく動画を視聴できますが、YouTubeのトラッキングメカニズムが適用される場合があります。"
        },
        advertising: {
          title: "広告パートナー:",
          description: "当社は、プラットフォームに広告を表示するために第三者広告パートナーと連携しています。これらのパートナーは、パーソナライズされた広告目的でお客様のブラウジング活動に関する情報を収集するために、Cookieおよび類似の技術を使用する場合があります。"
        }
      },
      dataSecurity: {
        title: "6. データセキュリティ",
        p1: "当社はお客様のデータのセキュリティを真剣に受け止め、不正アクセス、改ざん、開示、破壊からお客様の情報を保護するために適切な技術的および組織的措置を実施しています。ただし、インターネット経由の送信または電子保存の方法は100%安全ではないことにご注意ください。",
        p2: "当社のウェブサイトは業界標準のセキュリティプロトコルを使用し、安全なブラウジング体験を確保するためにGoDaddyセキュリティシールによって検証されています。"
      },
      privacyRights: {
        title: "7. プライバシー権利",
        p1: "お客様の個人情報に関して特定の権利があります:",
        list: {
          access: "アクセス: 当社が保持しているお客様に関するデータについて情報を要求できます",
          correction: "修正: 不正確な情報の修正を要求できます",
          deletion: "削除: 法的義務を条件に、データの削除を要求できます",
          optOut: "オプトアウト: Cookie設定を通じてパーソナライズされた広告をオプトアウトできます",
          portability: "データポータビリティ: ポータブル形式でのデータのコピーを要求できます"
        }
      },
      childrenPrivacy: {
        title: "8. 子供のプライバシー",
        p1: "Sudoku VSは一般の視聴者向けに設計されています。当社は13歳未満の子供から故意に個人情報を収集しません。保護者または後見人であり、お子様が当社に個人情報を提供したと思われる場合は、適切な措置を講じることができるよう当社に連絡してください。"
      },
      changes: {
        title: "9. プライバシーポリシーの変更",
        p1: "当社は、慣行の変更または法的、運営的、規制上の理由により、このプライバシーポリシーを随時更新する場合があります。重要な変更がある場合は、このページに新しいプライバシーポリシーを掲載し、以下の「最終更新日」を更新してお知らせします。",
        p2: "当社がお客様の情報をどのように保護しているかを把握するために、定期的にこのプライバシーポリシーを確認することをお勧めします。"
      },
      contact: {
        title: "10. お問い合わせ",
        p1: "このプライバシーポリシーまたはデータ慣行に関する質問、懸念、またはリクエストがある場合は、当社に連絡してください:",
        email: "メール: privacy@sudoku.vs",
        website: "ウェブサイト: www.sudoku.vs",
        p2: "できるだけ早くお問い合わせに対応します。"
      }
    },
    footer: {
      lastUpdated: "最終更新日: 2025年10月10日",
      effectiveDate: "発効日: 2025年10月10日"
    }
  },
languages: {
    en: "English",
    es: "Español", 
    fr: "Français",
    hi: "हिन्दी",
    bn: "বাংলা",
    pt: "Português",
    it: "Italiano",
    ru: "Русский",
    ja: "日本語",
    ko: "한국어"
},
  copywright: {
    text: 'Copyright © 2025 Software Architects Ltd. 無断複写・転載を禁じます。'
  }
};